<div class="acc-application-contact-dialog-part p-2">
	<div class="d-flex flex-column gap-2">
		<div class="row">
			<div class="col-md-6 mb-4">
				<h4>Applicant: {{participant().displayName}}</h4>
				<p>Default contact method: {{participant().contactMethod ?? 'N/A'}}</p>
				<common-button-row>
					<button class="btn btn-standard" (click)="sendEmail(participant().email!)">
						<i class="fa-regular fa-envelope"></i> Email
					</button>
					<button class="btn btn-standard" (click)="sendText(participant().phone!)">
						<i class="fa-regular fa-phone"></i> Contact
					</button>
					<button class="btn btn-standard" (click)="sendText(participant().phone!)">
						<i class="fa-regular fa-comment"></i> SMS
					</button>
				</common-button-row>
			</div>
			@for (coparticipant of coParticipants(); track coparticipant.personId) {
			<div class="col-md-6 mb-4">
				<h4>Co-Participant: {{coparticipant.displayName}}</h4>
				<p>Default contact method: {{coparticipant.contactMethod ?? 'N/A'}}</p>
				<common-button-row>
					<button class="btn btn-standard" (click)="sendEmail(coparticipant.email!)">
						<i class="fa-regular fa-envelope"></i> Email
					</button>
					<button class="btn btn-standard" (click)="sendText(coparticipant.phone!)">
						<i class="fa-regular fa-phone"></i> Contact
					</button>
					<button class="btn btn-standard" (click)="sendText(coparticipant.phone!)">
						<i class="fa-regular fa-comment"></i> SMS
					</button>
				</common-button-row>
			</div>
			}
		</div>
		<div>
			<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
				[rows]="contactRequests()"></grid-content>
		</div>
	</div>
</div>